import { render, staticRenderFns } from "./CampaignsTrendChart.vue?vue&type=template&id=a118c154&scoped=true"
import script from "./CampaignsTrendChart.vue?vue&type=script&lang=js"
export * from "./CampaignsTrendChart.vue?vue&type=script&lang=js"
import style0 from "./CampaignsTrendChart.vue?vue&type=style&index=0&id=a118c154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a118c154",
  null
  
)

export default component.exports